import React, { useEffect, useState } from "react"
import { ImageImgButton } from "./SingleButtton"
import { ReactComponent as SearchSvg } from "../style/images/btn_search.svg"
import { Controller, useFormContext } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleUp, faAngleDown, faXmark } from "@fortawesome/free-solid-svg-icons"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { Link } from "react-router-dom"
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const InputBox = ({usage, type, id, placeholder, value, onChange}) => {
  if (type === undefined) type = 'text'
  return (
    <div className={`${usage}_input`}>
      <input type={type} id={id} placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  )
}

const SearchBox = ({placeholder}) => {
  const [keyword, setKeyword] = useState('')
  return (
    <div className="search" >
      <input type="text" placeholder={placeholder} value={keyword} onChange={(evt)=>setKeyword(evt.target.value)} />
      {/*TODO: Search Button*/}
      <Link to={`/search?keyword=${keyword}`}><SearchSvg className="search_icon" /></Link>
    </div>
  )
}

const FormSelectionBox = ({name, options, optionTags, placeholder=""}) => {
  const { register } = useFormContext()
  if (Array.isArray(optionTags)) {
    return (
      <select {...register(name)} placeholder={placeholder}>
        {options.map((e, i) => {
          return <option value={e}>{optionTags&&optionTags[i]? optionTags[i]:i}</option>
        })}
      </select>
    )
  } else {
    return (
      <select {...register(name)} placeholder={placeholder}>
        {options.map((e) => {
          return <option value={e}>{optionTags&&optionTags[e]? optionTags[e]:e}</option>
        })}
      </select>
    )
  }
}

const SingleSelectionBox = ({options, optionValueMap, handleOnChange, placeholder='', value}) => {
  return (
    <select value={value} placeholder={placeholder} onChange={handleOnChange}>
      {options.map((e) => {
        return <option value={optionValueMap&&optionValueMap[e]? optionValueMap[e]:e}>{e}</option>
      })}
    </select>
  )
}

const SingleSelectionBox2 = ({options, optionValueMap, handleOnChange, placeholder='', value}) => {
  return (
    <select value={value} placeholder={placeholder} onChange={handleOnChange}>
      {options.map((e) => {
        return <option value={e}>{optionValueMap&&optionValueMap[e]? optionValueMap[e]:e}</option>
      })}
    </select>
  )
}

const MultiSelectionBox = ({name, options, optionTagMap=false, long=false}) => {
  const form = useFormContext()
  const [displayOptions, setDisplayOptions] = React.useState(false)
  const handleOnClick = (evt) => {
    setDisplayOptions(!displayOptions)
  }
  const Chip = ({ text }) => {
    return <span className="chip-text-body">{text}</span>;
  }
  const displayChips = (content) => {
    if (content === undefined || !content) return [];
    return content.map((e) => {
      return <Chip key={e} text={e} />
    })
  }
  const controlSelectedTagColor = (e) => {
    if (form.watch(name) && form.watch(name).includes(e)) return { backgroundColor: '#88bff7' }
    else return {}
  }
  return (
    <div className={long? "multi-selection-long-box":"multi-selection-box"} tabIndex={1000*Math.round(Math.random())} onBlur={()=>{setDisplayOptions(false)}}>
      <div className="msb-box-body">
        <div className="msb-box-selected">
          {displayChips(form.watch(name))}
        </div>
        <div className="msb-clear-all-btn" onClick={() => {form.setValue(name, [])}}>
          <FontAwesomeIcon icon={faXmark} />
        </div>
        <div className="msb-show-list-btn" onClick={handleOnClick}>
          {displayOptions ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}
        </div>
      </div>
      <div
        className="msb-drop-down-lists"
        style={displayOptions ? { display: "block" } : { display: "none" }}
      >
        {options.map((e) => {
          return (
            <div className="msb-option" style={controlSelectedTagColor(e)}>
              <label key={`lb_${e}`} htmlFor={e}>
                <input
                  id={e}
                  type="checkbox"
                  {...form.register(name)}
                  value={e}
                  style={{display: 'none'}}
                />
                {optionTagMap? <span>{optionTagMap[e]} {e}</span>:<span>{e}</span>}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  )
}

export const FormAutoCompleteBox = ({ control, options, box_class, fname, team }) => {
  return (
    <Controller
      render={(props) => (
        <Autocomplete
          value={props.field.value}
          className={box_class}
          options={team===undefined? options:options.filter((e=>e.team===team))}
          size="small"
          freeSolo
          ListboxProps={{style: {overflow: 'hidden'}}}
          getOptionLabel={(option) => option.label}
          renderOption={(option) => (
            <span style={{ fontSize: "1.5rem" }}>
              {option.label}
              <span style={{ color: "#777", fontSize: "1.1rem" }}>
                {" "}
                {option.team} {option.number}
              </span>
            </span>
          )}
          renderInput={(params) => (
            <div ref={params.InputProps.ref}>
              <input type="text" {...params.inputProps} />
            </div>
          )}
          onChange={(e, data) => {props.field.onChange(data)}}
          {...props}
        />
      )}
      onChange={([, data]) => data}
      name={fname}
      control={control}
    />
  )
}

export const AutoCompleteSearchBox = (placeholder, options) => {
  return (
    <Autocomplete
      options={options}
      size="small"
      freeSolo
      ListboxProps={{ style: { overflow: 'hidden' } }}
      getOptionLabel={(option) => option.label}
      renderOption={(option) => (
        <span style={{ fontSize: "1.5rem" }}>
          {option.label}
          <span style={{ color: "#777", fontSize: "1.1rem" }}>
            {" "}
            {option.team} {option.number}
          </span>
        </span>
      )}
      renderInput={(params) => <SearchBox params={params} placeholder={placeholder} />}
      // onChange={(e, data) => { props.field.onChange(data) }}
    />
  )
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelectChip({name, options, optionTagMap=false, long=false}) {
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const form = useFormContext()

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field }) => (
        <FormControl sx={{ m: 1, width: 300, backgroundColor: '#fff', marginTop: 0 }}>
          <Select
            {...field}
            labelId="demo-multiple-chip-label"
            id="demo-multiple-chip"
            multiple
            // value={personName}
            // onChange={handleChange}
            input={<OutlinedInput id="select-multiple-chip" sx={{ borderRadius: '100%' }} />}
            sx={{ border: 'none' }}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, border: 'none' }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} sx={{ padding: '1px', margin: '0' }} />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {options.map((name) => (
              <MenuItem key={name} value={name} style={getStyles(name, personName, theme)}>
                {optionTagMap && optionTagMap[name] ? optionTagMap[name] : name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
}

export { InputBox, SearchBox, FormSelectionBox, SingleSelectionBox, MultiSelectionBox, SingleSelectionBox2 }